import React from 'react';
import DownloadableReportTable from '../DownloadableReportTable';
import { useService } from '@Client/runner.hooks/useService';
import { SharedAngular } from '@Client/@types/sharedAngular';

const ProcessMapReportsTab = () => {
  const APP_CONFIG = useService<SharedAngular.APP_CONFIG>('APP_CONFIG');
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const reports = [
    {
      name: 'Process Maps Report',
      description: 'Basic information about process maps.',
      url: APP_CONFIG.apiBaseUrl + 'reports/processMaps/current/csv',
      parameters: {
        userTimeZone: userTimeZone
      }
    },
    {
      name: 'Process Usage Report',
      description:
        'How many times process maps have been viewed and commented on.',
      url: APP_CONFIG.apiBaseUrl + 'reports/processMaps/usage/csv',
      parameters: {
        userTimeZone: userTimeZone
      }
    }
  ];
  return (
    <div className="process-map-reports">
      <DownloadableReportTable reports={reports} />
    </div>
  );
};

export default ProcessMapReportsTab;
